import { useCallback, useState } from 'react';
import type { ReportMentionRef } from './reportMentionTypes';

export function useReportMentionDialog() {
  const [mention, setMention] = useState<ReportMentionRef | null>(null);
  const [open, setOpen] = useState(false);

  const onMentionClick = useCallback((ref: ReportMentionRef) => {
    setMention(ref);
    setOpen(true);
  }, []);

  const onOpenChange = useCallback((next: boolean) => {
    setOpen(next);
    if (!next) setMention(null);
  }, []);

  return {
    mention,
    open,
    onOpenChange,
    onMentionClick,
  };
}
